import { FunctionComponent } from 'react';
import Slideshow from 'types/Slideshow';
import CoverSlide from 'components/Slideshow/CoverSlide';
import SlideshowSlide from './SlideshowSlide';

interface MobileSlideshowProps {
  slideshow: Slideshow;
}

const MobileSlideshow: FunctionComponent<MobileSlideshowProps> = ({
  slideshow,
}: MobileSlideshowProps) => {
  const { slides, coverSlide } = slideshow;

  return (
    <div>
      <CoverSlide slide={coverSlide} />
      {slides.map((slide, idx) => (
        <SlideshowSlide
          slide={slide}
          index={idx}
          key={slide.photoUrl}
          total={slides.length}
          desktop={false}
          adTargeting={slide.adTargeting}
        />
      ))}
    </div>
  );
};

export default MobileSlideshow;
